import React from 'react';
import Style from './Header.module.css';
import Avatar from '../controls/avatar/Avatar';

const TopBarUserIcon = (props) => {
  const { user, show, handleToggle } = props;
  const toggleMenu = () => {
    handleToggle(!show)
  };

  return (
    <div className={`position-relative ${Style.profileWrapper}`}>
      <div onClick={toggleMenu}>
        {user && user.profilePictureUrl !== null ? <img src={user.profilePictureUrl} className={Style.profile} alt="" /> : <Avatar name={user ? user.fullName : ''} />}
      </div>
    </div>
  );
};

export default TopBarUserIcon;